import * as React from 'react';
import {status} from "../constants";
import {abbreviationName} from '../../../../common/util';
import UserImage from '../../../../components/UserImage/index';

export default class ActivityTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.renderTemplate = this.renderTemplate.bind(this);
    }

    renderTemplate(data, type) {
        switch (type) {
            case "Update":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a>{` in `}
                        <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a>{` has been edited `}
                        </span>
                    </React.Fragment>
                );
            case "Reject":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}> {data.WorkkardNo}</a> has been Rejected
                        </span>
                    </React.Fragment>
                );
            case "Accept":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.ActivityDetailUrl}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}> {data.WorkkardNo}</a> has been Accepted
                        </span>
                    </React.Fragment>
                );

            case "ProgressIncrease":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        Progress of <a href={data.ActivityDetailUrl}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}> {data.WorkkardNo}</a> has been increased from {data.FromResolution}% to {data.ToResolution}%
                        </span>
                    </React.Fragment>
                );
            case "InProgressDecrease":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        Progress of <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}> {data.WorkkardNo}</a> has been decreased from {data.FromResolution}% to {data.ToResolution}%
                        </span>
                    </React.Fragment>
                );
            case "Complete":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}> {data.WorkkardNo}</a> has been Completed
                        </span>
                    </React.Fragment>
                );
            case "Close":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}> {data.WorkkardNo}</a> has been Closed
                        </span>
                    </React.Fragment>
                );

            case "Reopened":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}> {data.WorkkardNo}</a> has been Reopened
                        </span>
                    </React.Fragment>
                );

            case "ClosedMidterm":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a> has been Closed-Midterm
                        </span>
                    </React.Fragment>
                );

            case "NoteAdded":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {
                        (data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                        <span className="welcome_txt">
                            <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a> has been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                        </span>
                        :  
                        (
                            ( data.NoteText != "")?
                            <span className="welcome_txt">
                            <a href={data.ActivityNoteDetailUrl}>{data.NoteText}</a> note has been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :
                            <span className="welcome_txt">
                            A <a href={data.ActivityNoteDetailUrl}>Note</a> has been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                        )                                                             
                        }
                    </React.Fragment>
                );
            case "NoteWithFileOnlyAdded":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {(data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>File(s)</a> have been added with <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a>, for <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>File(s)</a> have been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                        }
                    </React.Fragment>
                );
            case "NotePublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {
                            (data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a> has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :  
                            (
                                ( data.NoteText != "")?
                                <span className="welcome_txt markedCreator">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteText}</a> note has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                                </span>
                                :
                                <span className="welcome_txt">
                                A <a href={data.ActivityNoteDetailUrl}>Note</a> has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                                </span>
                            )                                                             
                        }
                    </React.Fragment>
                );

            case "PrivateActivityNoteAdded":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {
                            (data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a> has been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :  
                            (
                            ( data.NoteText != "")?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteText}</a> note has been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :
                            <span className="welcome_txt">
                                A <a href={data.ActivityNoteDetailUrl}>Note</a> has been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            )                                                             
                        }
                    </React.Fragment>
                );

            case "PrivateActivityNotePublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {
                            (data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a> has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :  
                            (
                            ( data.NoteText != "")?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteText}</a> note has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :
                            <span className="welcome_txt">
                                A <a href={data.ActivityNoteDetailUrl}>Note</a> has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            )                                                             
                        }
                    </React.Fragment>
                );

            case "PrivateActivityNoteWithFileOnlyPublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {(data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                            <span className="welcome_txt"><a href={data.ActivityNoteDetailUrl}>File(s)</a> have been published with <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a>, for <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a></span>
                        :
                            <span className="welcome_txt"><a href={data.ActivityNoteDetailUrl}>File(s)</a> have been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a></span>
                        }
                    </React.Fragment>
                );

            case "PersonalActivityNotePrivatePublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {
                            (data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a> has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :  
                            (
                            ( data.NoteText != "")?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteText}</a> note has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :
                            <span className="welcome_txt">
                                A <a href={data.ActivityNoteDetailUrl}>Note</a> has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            )                                                             
                        }
                        </React.Fragment>
                );

            case "PersonalActivityNoteWithFileOnlyPrivatePublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {(data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                            <span className="welcome_txt"><a href={data.ActivityNoteDetailUrl}>File(s)</a> have been published with <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a>, for <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a></span>
                        :
                            <span className="welcome_txt"><a href={data.ActivityNoteDetailUrl}>File(s)</a> have been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a></span>
                        }
                    </React.Fragment>
                );

            case "PersonalActivityNotePublicPublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {
                            (data.NoteTemplateName != "" && data.NoteTemplateName != null ) ?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a> has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :  
                            (
                            ( data.NoteText != "")?
                            <span className="welcome_txt">
                                <a href={data.ActivityNoteDetailUrl}>{data.NoteText}</a> note has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            :
                            <span className="welcome_txt">
                                A <a href={data.ActivityNoteDetailUrl}>Note</a> has been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                            </span>
                            )                                                             
                        }
                    </React.Fragment>
                );

            case "PersonalActivityNoteWithFileOnlyPublicPublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {data.NoteTemplateName != ""?
                            <span className="welcome_txt"><a href={data.ActivityNoteDetailUrl}>File(s)</a> have been published with <a href={data.ActivityNoteDetailUrl}>{data.NoteTemplateName}</a>, for <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a></span>
                        :
                            <span className="welcome_txt"><a href={data.ActivityNoteDetailUrl}>File(s)</a> have been published to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a></span>
                        }
                    </React.Fragment>
                );

            case "Watcher":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <div className="welcome_txt">
                            <a href={data.TriggeredByUserProfile} className="name" title={data.TriggeredByFullNameFull}>{data.TriggeredByFullName}</a> invited you to follow <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a>
                        </div>
                    </React.Fragment>
                );
        }
    }

    render() {
        const {extraData}=this.props;
        return (
            <div className={extraData.displayMarkReadIcon ? (`card ${extraData.IsGroupByEnabled  && !extraData.showGroupedNotificationDetail ? 'cardGroup' :'cardPlain'} ${this.props.data.Status == status.read ? 'cardGroupRead' : ''}`):''} onClick={()=>{(extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail) ? this.props.handleCardClick(this.props.data) :false}}>
                {
                    extraData.displayMarkReadIcon && 
                    <React.Fragment>
                        {
                            <span className="posRight quickTooltip-bottom" data-quicktooltip={this.props.data.Status == status.read ? "mark as unread": "mark as read"} 
                            onClick={(e)=>{
                                e.stopPropagation();
                                        if(this.props.data.Status == status.read)
                                            extraData.handleMarkRead(this.props.data,status.unRead)
                                        else
                                            extraData.handleMarkRead(this.props.data,status.read)
                                        }}>
                                <em className={`read ${this.props.data.Status == status.read ? "unread":""}`}></em>
                            </span>
                        }
                        {extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail?<div className="rwoFlex alignMiddle wkNumber">
                            <label className="badges wkSymbol mr__1">{this.props.data.WorkkardId?'W':'0'}</label> {this.props.data.WorkkardNo?this.props.data.WorkkardNo:'Others'}
                            {
                                extraData.IsGroupByEnabled && extraData.GroupNotificationCounter > 0 && <label className="newCard ml__1">{extraData.GroupNotificationCounter > 99 ? '99+' : extraData.GroupNotificationCounter} new{extraData.RecentWorkkardCountRecieved && <span className="newCardNotification"></span>}</label>
                            }
                        </div> : this.props.data.AllNotificationCount > 0 ? <div className="rwoFlex alignMiddle"><label className="newCard">new</label></div> : null} 
                    </React.Fragment>
                }
                <div className={extraData.displayProfilePic ? "rowFlex mt activity_desc":"rowFlex activity_desc"}>
                    {
                        extraData.displayProfilePic && 
                        <div className="badges badgesSmall mr">
                             <UserImage profileUrl={this.props.data.TriggeredByProfileImage} size="22" className="profilePic" profileName={this.props.data.TriggeredByFullName} /> 
                                                 
                        </div>
                    }
                    <div className={extraData.displayProfilePic ?"":"notificationDate"}> 
                        {
                            extraData.displayTriggerByName && 
                            <>
                                <span className="userName flexGrow" onClick={(e)=>extraData.onProfileClick(e,this.props.data.TriggeredById,'user')}>{this.props.data.TriggeredByFullName}</span>
                                {extraData.showGroupedNotificationDetail && <label>{abbreviationName(this.props.data.TriggeredByOrganisationNameFull)}</label>}
                            </>
                        }                                
                        {this.renderTemplate(this.props.data, this.props.type)}
                        <label className={extraData.displayProfilePic ? "notification__time" : "notification__time gray"}>{extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </div>
                </div>
            </div>
        );
    }
}